import { RMRInfo } from "../types/rmr-info.dto";

export const RMR_INFO: RMRInfo = {
    id: crypto.randomUUID(),
    address: "г. Омск, Проспект Карла Маркса, 38",
    phone: "+7 (999) 955-11-00",
    workSchedule: [
        "08:30-17:45",
        "08:30-17:45",
        "08:30-17:45",
        "08:30-17:45",
        "08:30-16:30",
        "Закрыто",
        "Закрыто"
    ],
    latitude: 54.953800,
    longitude: 73.387367,
    name: 'Работа молодёжи России'
} as const;